import ZoomControls from "./functional";
export default ZoomControls;
